module.exports = __webpack_public_path__ + "static/media/1463978_10203446206016343_1972701693778362550_n.6f6cc6c5.jpg";